export default {
  SET_SHOW_ROUTINE_DELETE_MODAL(state, payload) {
    state.showRoutineDeleteModal = payload === undefined ? !state.showRoutineDeleteModal : payload
  },
}
